import { render, staticRenderFns } from "./DataTableView.vue?vue&type=template&id=173a8ebf&scoped=true"
import script from "./DataTableView.vue?vue&type=script&lang=js"
export * from "./DataTableView.vue?vue&type=script&lang=js"
import style0 from "./DataTableView.vue?vue&type=style&index=0&id=173a8ebf&prod&lang=scss&scoped=true"
import style1 from "./DataTableView.vue?vue&type=style&index=1&id=173a8ebf&prod&scoped=true&lang=css"
import style2 from "./DataTableView.vue?vue&type=style&index=2&id=173a8ebf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "173a8ebf",
  null
  
)

export default component.exports